(() => {
  if (customElements.get('shopde-world-product-list')) return;
  class WorldProducts extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.grid = this.querySelector('[data-world-grid]');
      this.status = this.querySelector('[data-world-status]');
      this.pagination = this.querySelector('nav');
      this.page = 0;
      this.cards = new Map();
      this.failed = false;
      this.loading = true;
      this.querySelector('[data-world-prev]').addEventListener('click', () => { this.page--; this.render(true); }, { signal: this.controller.signal });
      this.querySelector('[data-world-next]').addEventListener('click', () => { this.page++; this.render(true); }, { signal: this.controller.signal });
      this.querySelector('[data-world-retry]').addEventListener('click', () => location.reload(), { signal: this.controller.signal });
      const fragment = this.querySelector('template').content;
      const sources = [...new Set([...fragment.querySelectorAll('a[href]')].filter(a => !a.closest('.shopde-world-brands')).map(a => this.source(a.href)).filter(Boolean))];
      this.load(sources);
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    source(path) {
      const url = new URL(path, location.origin);
      if (url.origin !== location.origin || !/\/collections\/[^/]+(?:\/[^/]+)?\/?$/.test(url.pathname) || /\/collections\/all\/?$/.test(url.pathname)) return null;
      url.searchParams.delete('view');
      url.searchParams.delete('page');
      return url.href;
    }
    async load(sources) {
      const signal = this.controller.signal;
      const visited = new Set();
      const worker = async () => {
        while (sources.length && !signal.aborted) {
          let next = sources.shift();
          try {
            while (next && !signal.aborted) {
              const url = new URL(next, location.origin);
              url.searchParams.set('section_id', 'shopde-world-product-feed');
              const preview = new URLSearchParams(location.search).get('preview_theme_id');
              if (preview) url.searchParams.set('preview_theme_id', preview);
              if (visited.has(url.href)) break;
              visited.add(url.href);
              let response;
              for (let attempt = 0; attempt < 3; attempt++) {
                response = await fetch(url, { signal });
                if (response.status !== 429 && response.status < 500) break;
                await new Promise(resolve => setTimeout(resolve, 1000 * (attempt + 1)));
              }
              if (!response.ok) throw new Error('Collection response');
              const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
              const feed = doc.querySelector('[data-world-product-feed]');
              if (!feed) throw new Error('Missing collection feed');
              feed.querySelectorAll('[data-world-product]').forEach(card => {
                if (this.cards.has(card.dataset.worldProduct)) return;
                card.classList.add('grid__item');
                this.cards.set(card.dataset.worldProduct, card);
              });
              next = feed.dataset.nextPage ? new URL(feed.dataset.nextPage, url).href : null;
              this.render();
            }
          } catch (error) { if (error.name !== 'AbortError') this.failed = true; }
        }
      };
      await Promise.all([worker(), worker()]);
      if (this.controller?.signal.aborted || !this.isConnected) return;
      this.loading = false;
      this.grid.setAttribute('aria-busy', 'false');
      this.render();
    }
    render(scroll = false) {
      const cards = [...this.cards.values()];
      const pages = Math.max(1, Math.ceil(cards.length / 24));
      this.page = Math.max(0, Math.min(this.page, pages - 1));
      this.grid.replaceChildren(...cards.slice(this.page * 24, (this.page + 1) * 24));
      this.status.textContent = this.loading ? this.dataset.loading : this.failed ? this.dataset.error : cards.length ? this.dataset.count.replace('[count]', String(cards.length)) : this.dataset.empty;
      this.querySelector('[data-world-retry]').hidden = !this.failed || this.loading;
      this.pagination.hidden = pages < 2;
      this.querySelector('[data-world-page]').textContent = `${this.page + 1} / ${pages}`;
      this.querySelector('[data-world-prev]').disabled = this.page === 0;
      this.querySelector('[data-world-next]').disabled = this.page >= pages - 1;
      if (scroll) this.scrollIntoView({ block: 'start' });
    }
  }
  customElements.define('shopde-world-product-list', WorldProducts);
})();
